
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';

import theme from '../common/theme';

const classNames = mergeStyleSets({
    toolbar: {
    }
});

const styles = {
    label: {
        color: theme.fabricTheme.semanticColors.link
    },
    labelHovered: {
        color: theme.fabricTheme.semanticColors.linkHovered
    },
    labelDisabled: {
        color: theme.fabricTheme.semanticColors.buttonTextDisabled
    }
};

const ToolbarCommandButton = (props) => {
    const horizontalAlign = props.horizontalAlign || 'end';

    const getIconProps = (menuItem) => {
        return menuItem.icon
            ? {iconName: menuItem.icon}
            : null;
    }

    const getMenuProps = (toolbarItem) => {
        return toolbarItem.items
            ? {
                items: toolbarItem.items.map((item, index) => {
                    return {
                        key: index,
                        text: item.text,
                        title: item.title,
                        onClick: item.onClick,
                        iconProps: getIconProps(item)
                    };
                })
            }
            : null;
    }

    return (
        <Stack
            horizontal
            horizontalAlign={horizontalAlign}
            className={classNames.toolbar}
        >
            {props.items.map((item, index) => {
                return (
                    <CommandButton
                        key={index}
                        onClick={item.onClick}
                        text={item.text}
                        title={item.title}
                        styles={styles}
                        disabled={item.disabled || (!item.onClick && !item.items)}
                        menuProps={getMenuProps(item)}
                    />
                );
            })}
        </Stack>
    )
}

export default ToolbarCommandButton;
